import React from "react";
// import "./Column2.css";

function Column2(props) {
  const { colum2text } = props;
console.log(colum2text+"colum test");
  return (
    <div className="column-2-3">
      <p className="lorem-ipsum-is-simpl poppins-medium-limed-spruce-30px">{colum2text}</p>
    </div>
  );
}

export default Column2;
